export enum PATHS {
    HOME='/',
    COMING_SOON='/comingSoon',
    CONTACT='/contact'
}